class RequestHelper {
  static abortController: AbortController | null = null;
}

export default RequestHelper;